import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, ArrowLeft, Sparkles } from 'lucide-react';
import { Button } from '../components/ui/button';

const BewerbungErfolgreich = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Bewerbung erfolgreich | Bad Girl's Society</title>
        <meta name="description" content="Deine Bewerbung wurde erfolgreich eingereicht. Wir melden uns zeitnah bei dir." />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href="https://bad-girl-society.com/bewerbung-erfolgreich" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Bewerbung erfolgreich | Bad Girl's Society" />
        <meta property="og:description" content="Deine Bewerbung wurde erfolgreich eingereicht." />
        <meta property="og:url" content="https://bad-girl-society.com/bewerbung-erfolgreich" />
      </Helmet>

      <div className="min-h-screen bg-black text-white flex items-center justify-center px-4 py-12">
        <div className="max-w-2xl w-full text-center space-y-8">
          {/* Success Icon */}
          <div className="flex justify-center">
            <div className="relative">
              <CheckCircle 
                size={120} 
                className="text-gold animate-[scale-in_0.5s_ease-out]" 
                strokeWidth={1.5}
              />
              <Sparkles 
                size={32} 
                className="text-gold absolute -top-2 -right-2 animate-pulse" 
              />
            </div>
          </div>

          {/* Heading */}
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gold">
              Bewerbung erfolgreich eingegangen!
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-transparent via-gold to-transparent mx-auto"></div>
          </div>

          {/* Message */}
          <div className="space-y-6 text-lg md:text-xl text-white/90 leading-relaxed">
            <p>
              Vielen Dank für deine Bewerbung bei <span className="text-gold font-semibold">Bad Girl's Society</span>.
            </p>
            <p>
              Wir haben deine Anfrage erhalten und werden uns zeitnah bei dir melden.
            </p>
            <p className="text-base text-white/70">
              Bitte überprüfe auch deinen Spam-Ordner, falls du innerhalb der nächsten 48 Stunden keine E-Mail von uns erhältst.
            </p>
          </div>

          {/* Back Button */}
          <div className="pt-8">
            <Button
              onClick={() => navigate('/')}
              size="lg"
              className="bg-gradient-to-r from-gold via-gold to-[#b8941f] hover:from-[#b8941f] hover:via-gold hover:to-gold text-black font-semibold px-8 py-6 text-lg transition-all duration-300 shadow-lg hover:shadow-gold/50"
            >
              <ArrowLeft size={20} className="mr-2" />
              Zurück zur Startseite
            </Button>
          </div>

          {/* Decorative Elements */}
          <div className="pt-12 flex justify-center gap-2">
            <div className="w-2 h-2 bg-gold rounded-full animate-pulse"></div>
            <div className="w-2 h-2 bg-gold rounded-full animate-pulse delay-100"></div>
            <div className="w-2 h-2 bg-gold rounded-full animate-pulse delay-200"></div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scale-in {
          0% {
            transform: scale(0);
            opacity: 0;
          }
          50% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </>
  );
};

export default BewerbungErfolgreich;
